module.exports = __webpack_public_path__ + "img/americano-thumb.a869daf6.png";